// import ReactQuill from 'react-quill';

// import { Text } from '@pentabd/ui';

const RichTextEditor = () => {
  return (
    <div className="my-8">
      {/* <ReactQuill
        theme="snow"
        value={editorContent}
        onChange={onEditorStateChange}
      />
      <Text color="danger" size="sm" className="lh-sm mt-5" component="p">
        {errors?.richTextEditor?.message as any}
      </Text> */}
    </div>
  );
};

export default RichTextEditor;
